import { Addvert } from "../../App";

export const formatPrice = (price) => {
   
    let tempPrice = price;

    if( tempPrice === '' || tempPrice === undefined ){
        return 
    }else{
        let newPrice = price.toString();
        let StringPrice = ''
        for (let i = 1; i < parseInt((newPrice.length-1)/3)+2; i++) {
            let start = newPrice.length-(i*3);
            let end = newPrice.length - ((i-1)*3);
            if (start < 0){
                tempPrice = newPrice.slice(0,end)
            } else {
                tempPrice = newPrice.slice(start,end)
            }
            if (i === 1){
                StringPrice = tempPrice;
            } else {
                StringPrice = tempPrice + ',' + StringPrice;
            }
        }
        return StringPrice;
    }
}
export const checkPriceCut = (shcode, g_code = 0) => {
    if(!shcode) {
        return false;
    }
    if(shcode === 15 || shcode === 14){
        return false;
    }
    if(epectProd.findIndex(v => v=== g_code) !== -1){
        return false;
    }
    if(!Addvert) {
        return false;
    }
    return true;
}
const epectProd = [
    2076,
    2077,
    2078,
    2079,
    2089,
    2090,
    2131,
]

export const changePrice = (price) => {
    let newp = price*1.176470588;
    newp = Math.round(newp/1000)*1000
    return newp
}